export default "__VITE_ASSET__DI69Y3qb__"